import { Switch } from '@bifeai/ui';
import type { ReactNode } from 'react';

/** Llave sí/no con su texto a la izquierda (y una ayuda debajo, si hace falta). */
export function SwitchRow({
  label,
  hint,
  checked,
  onChange,
  disabled,
}: {
  label: string;
  hint?: ReactNode;
  checked: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <div className="bf-switch-row">
      <div>
        <span className="bf-switch-row-label">{label}</span>
        {hint && <p className="bf-hint">{hint}</p>}
      </div>
      <Switch label={label} checked={checked} onCheckedChange={onChange} disabled={disabled} />
    </div>
  );
}
